const Logo: React.FC<React.ComponentProps<"svg">> = ({ ...props }) => {
  return (
    <svg
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0H28C34.6274 0 40 5.37258 40 12V28C40 34.6274 34.6274 40 28 40H12C5.37258 40 0 34.6274 0 28V12Z"
        fill="currentColor"
        className="text-[#18181B] dark:text-white"
      ></path>
      <path
        d="M30.9932 25.3751C32.5435 23.8724 33.3333 22.0808 33.3333 20.0002C33.3333 17.9196 32.5435 16.1279 30.9932 14.6541C29.4429 13.1515 27.5708 12.4001 25.377 12.4001C23.1831 12.4001 21.311 13.1515 19.7607 14.6541C18.2104 16.1279 17.4498 17.9196 17.4498 20.0002C17.4498 22.0808 18.2104 23.8724 19.7607 25.3751C21.311 26.8489 23.1831 27.6002 25.377 27.6002C27.5708 27.6002 29.4429 26.8489 30.9932 25.3751ZM26.8103 26.7911C25.9912 26.7911 25.2307 26.2131 24.5287 25.0572C23.8266 23.9013 23.3001 22.5721 22.9198 21.0983C22.5688 19.5956 22.3933 18.2374 22.3933 16.9948C22.3933 14.4808 22.8906 13.2382 23.8851 13.2382C24.6749 13.2382 25.4355 13.8161 26.1667 14.9431C26.898 16.0701 27.4245 17.3416 27.8048 18.8154C28.1851 20.2892 28.3898 21.6184 28.3898 22.8321C28.3898 25.2595 27.8341 26.7911 26.8103 26.7911Z"
        fill="currentColor"
        className="text-white dark:text-[#0B1115]"
      ></path>
      <path
        d="M20.21 25.3751C21.7603 23.8724 22.5501 22.0808 22.5501 20.0002C22.5501 17.9196 21.7603 16.1279 20.21 14.6541C18.6597 13.1515 16.7876 12.4001 14.5937 12.4001C12.3999 12.4001 10.5278 13.1515 8.97749 14.6541C7.42716 16.1279 6.66663 17.9196 6.66663 20.0002C6.66663 22.0808 7.42716 23.8724 8.97749 25.3751C10.5278 26.8489 12.3999 27.6002 14.5937 27.6002C16.7876 27.6002 18.6597 26.8489 20.21 25.3751ZM16.0271 26.7911C15.208 26.7911 14.4475 26.2131 13.7455 25.0572C13.0434 23.9013 12.5169 22.5721 12.1366 21.0983C11.7856 19.5956 11.6101 18.2374 11.6101 16.9948C11.6101 14.4808 12.1074 13.2382 13.1019 13.2382C13.8917 13.2382 14.6523 13.8161 15.3835 14.9431C16.1148 16.0701 16.6413 17.3416 17.0216 18.8154C17.4019 20.2892 17.6066 21.6184 17.6066 22.8321C17.6066 25.2595 17.0509 26.7911 16.0271 26.7911Z"
        fill="currentColor"
        className="text-white dark:text-[#0B1115]"
      ></path>
    </svg>
  );
};
Logo.displayName = "Logo";

export { Logo };
